import React from "react";
import Loader from "components/Loader";

const useStyle = {
  encodeLoader: {
    position: "absolute",
    width: "100%",
    height: "100%",
    top: "0",
    left: "0",
    right: "0",
    bottom: "0",
    backgroundColor: "rgba(0,0,0,0.5)",
    zIndex: "2",
    cursor: "pointer",
  },
  loaderStyle: {
    display: "flex",
    justifyContent: "center",
    paddingTop: "30px",
  },
  encodeText: {
    display: "flex",
    padding: "30px 0",
    justifyContent: "center",
    color: "white",
    root: {
      backgroundColor: "transparent",
    },
  },
  cancelEncodeButton: {
    display: "flex",
    justifyContent: "center",
    paddingTop: "7px",
  },
};

export default ({ loading }) => {
  const classes = useStyle;
  return (
    <>
      {loading && (
        <div style={classes.encodeLoader}>
          <Loader loaderStyle={classes.loaderStyle} />
          <div style={classes.encodeText}>
            <h6 style={{ fontSize: "20px" }}>Video is encoding kindly wait</h6>
          </div>
          <div style={classes.cancelEncodeButton}></div>
        </div>
      )}
    </>
  );
};
